import { render } from "./generalreport.vue?vue&type=template&id=553754e2&scoped=true"
import script from "./generalreport.vue?vue&type=script&lang=js"
export * from "./generalreport.vue?vue&type=script&lang=js"

import "./generalreport.vue?vue&type=style&index=0&id=553754e2&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553754e2"]])

export default __exports__